import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {
  FormQuestionFilter,
  RecommendationConfig,
  RetailerApplicationAssessment
} from '@core/model/retailer/application-form.model';
import {environment} from "@env/environment";
import {GenericService} from "@ui-kit/framework/common/generic.service";
import {toRequestParams} from "@ui-kit/framework/util/static/http-utils";
import {Observable} from "rxjs";


import {Retailer} from "../retailers/retailers.model";

@Injectable({
  providedIn: 'root'
})
export class ApplicationsService extends GenericService<Retailer> {
  constructor(http: HttpClient) {
    super(http, environment.apiRetailersHost + `/console/offering/district/pipeline/applications`);
  }

  getLatestRetailerAssessment(retailerId: string): Observable<RetailerApplicationAssessment> {
    return this.http.get<RetailerApplicationAssessment>(this.getBaseUrl + `/${retailerId}/assessment`);
  }

  getAssessmentRecommendation(retailerId: string): Observable<RecommendationConfig> {
    return this.http.get<RecommendationConfig>(this.getBaseUrl + `/${retailerId}/assessment/recommendation`);
  }

  getAssessmentImages(retailerId: string): Observable<FormQuestionFilter[]> {
    return this.http.get<FormQuestionFilter[]>(this.getBaseUrl + `/${retailerId}/assessment/images`);
  }

  updateCurateDetails(retailerId: string, curateDetails: RetailerApplicationAssessment): Observable<RetailerApplicationAssessment> {
    return this.http.post<RetailerApplicationAssessment>(this.getBaseUrl + `/${retailerId}/assessment`, curateDetails);
  }

  downloadFormFile(retailerId: string, fileId: string, questionFilter: FormQuestionFilter): Observable<ArrayBuffer> {
    questionFilter.fileValue = null;
    const requestParams = toRequestParams(questionFilter);

    const options = { responseType: 'arraybuffer' as 'json', params: requestParams };
    return this.http.get<ArrayBuffer>(this.getBaseUrl + `/${retailerId}/file-download/${fileId}`, options);
  }

  get getBaseUrl() {
    return environment.apiRetailersHost + `/console/offering/district/pipeline/applications`;
  }
}
